import React from 'react';
import PropTypes from 'prop-types';

const Info = ({
  fill = 'var(--SECONDARY_LIGHT)',
  className = '',
  width = '18',
  height = '18',
}) => (
  <svg
    width={width || '18'}
    height={height || '18'}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9 17.16C7.3861 17.16 5.80845 16.6814 4.46655 15.7848C3.12464 14.8882 2.07875 13.6137 1.46114 12.1227C0.843532 10.6317 0.681937 8.99095 0.996792 7.40806C1.31165 5.82518 2.08881 4.37121 3.23001 3.23001C4.37121 2.08881 5.82518 1.31165 7.40806 0.996792C8.99095 0.681937 10.6317 0.843532 12.1227 1.46114C13.6137 2.07875 14.8882 3.12464 15.7848 4.46655C16.6814 5.80845 17.16 7.3861 17.16 9C17.158 11.1636 16.2977 13.2379 14.7678 14.7678C13.2379 16.2977 11.1636 17.158 9 17.16ZM9 2.535C7.72134 2.535 6.4714 2.91417 5.40824 3.62455C4.34507 4.33493 3.51644 5.34463 3.02712 6.52595C2.5378 7.70728 2.40977 9.00717 2.65922 10.2613C2.90868 11.5153 3.52441 12.6673 4.42855 13.5714C5.3327 14.4756 6.48465 15.0913 7.73874 15.3408C8.99283 15.5902 10.2927 15.4622 11.474 14.9729C12.6554 14.4836 13.6651 13.6549 14.3755 12.5918C15.0858 11.5286 15.465 10.2787 15.465 9C15.463 7.28598 14.7812 5.64274 13.5693 4.43075C12.3573 3.21875 10.714 2.53699 9 2.535Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 4.60499C9.23023 4.60499 9.45529 4.67337 9.64662 4.80144C9.83795 4.92951 9.98694 5.11151 10.0747 5.32437C10.1625 5.53723 10.185 5.77135 10.1396 5.99705C10.0941 6.22276 9.98265 6.42988 9.81932 6.59216C9.65599 6.75443 9.44815 6.86455 9.22216 6.90856C8.99616 6.95256 8.76219 6.92847 8.5499 6.83933C8.33762 6.75019 8.15659 6.60003 8.02976 6.40787C7.90292 6.21571 7.83601 5.99022 7.8375 5.75999C7.83749 5.60768 7.86761 5.45687 7.92613 5.31625C7.98464 5.17563 8.07039 5.04797 8.17843 4.94062C8.28648 4.83327 8.41469 4.74835 8.55569 4.69075C8.69669 4.63315 8.84769 4.604 9 4.60499Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7775 13.5C10.8332 13.5 10.8866 13.4779 10.926 13.4385C10.9654 13.3991 10.9875 13.3457 10.9875 13.29V12.855C10.9875 12.8274 10.9821 12.8001 10.9715 12.7746C10.961 12.7492 10.9455 12.726 10.926 12.7065C10.9065 12.687 10.8833 12.6715 10.8579 12.661C10.8324 12.6504 10.8051 12.645 10.7775 12.645H10.11V7.95C10.111 7.92214 10.1063 7.89436 10.0962 7.86841C10.086 7.84245 10.0705 7.81888 10.0508 7.79916C10.0311 7.77945 10.0075 7.76402 9.98159 7.75384C9.95564 7.74366 9.92786 7.73894 9.9 7.74H7.1925C7.1368 7.74 7.08339 7.76212 7.04401 7.8015C7.00462 7.84089 6.9825 7.8943 6.9825 7.95V8.3775C6.9825 8.43319 7.00462 8.48661 7.04401 8.52599C7.08339 8.56537 7.1368 8.5875 7.1925 8.5875H7.89V12.6675H7.215C7.1599 12.6694 7.10756 12.6921 7.06858 12.7311C7.02959 12.7701 7.00687 12.8224 7.005 12.8775V13.3125C7.00687 13.3676 7.02959 13.4199 7.06858 13.4589C7.10756 13.4979 7.1599 13.5206 7.215 13.5225H10.7775V13.5Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

Info.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default Info;
